<template>
  <div id="home">
    <v-container class="fill-height" fluid> 
        <v-row align="center">
                   <v-col cols="3" sm="3" md="3" class="pa-0 padding-bottom-0">
                  <v-select v-model="filterdate"  :items="filterdates"   @change="getAdserverWebsitesStats()" label="--Filter By--"  class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
                  <v-col cols="3" sm="3" md="3" class="pa-0 pl-3 padding-bottom-0">
                  <v-menu ref="webstatsfrom_date"  v-model="webstatsfrom_date"  :close-on-content-click="false"
                      :return-value.sync="webstatsfrom_date" transition="scale-transition"  offset-y  min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field  v-model="webstatsfromdate"  label="From Date"
                          prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker  v-model="webstatsfromdate"  no-title  scrollable>
                        <v-spacer></v-spacer>
                        <v-btn    text  color="primary"  @click="webstatsfromdate = false">
                          Cancel    </v-btn>
                        <v-btn  text   color="primary" @click="$refs.webstatsfrom_date.save(webstatsfrom_date)" >OK</v-btn>
                      </v-date-picker>
                  </v-menu>
                  </v-col>
                    <v-col cols="3" sm="3" md="3" class="pa-0 pl-3 padding-bottom-0">
                  <v-menu ref="webstatsto_date"  v-model="webstatsto_date"  :close-on-content-click="false"
                      :return-value.sync="webstatsto_date" transition="scale-transition"  offset-y  min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field            v-model="webstatstodate"            label="To Date"
                          prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker  v-model="webstatstodate"  no-title  scrollable>
                        <v-spacer></v-spacer>
                        <v-btn    text  color="primary"  @click="webstatstodate = false">
                          Cancel    </v-btn>
                        <v-btn  text   color="primary" @click="$refs.webstatsto_date.save(webstatsto_date)" >OK</v-btn>
                      </v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col cols="2" sm="2" md="2" class="pa-0 pl-3 padding-bottom-0">
                        <v-btn  small depressed color="primary" @click="getAdserverWebsitesStats()"><v-icon left>mdi-file-search-outline
                          </v-icon>Search</v-btn>
                  </v-col>
                <v-col cols="11" class="pa-0" sm="12" md="12">
                      <v-divider class="pa-0 blue darken-1" ></v-divider>
                  </v-col>      
        </v-row>   
        
       <v-row justify="start">
             <template v-for="(getwebsite) in websitestatslist" >
                    <v-col :key="getwebsite.websiteid" v-if="getwebsite.websiteslug != 'pi3ck' && getwebsite.websiteslug != 'risk' && getwebsite.websiteslug != 'mynews24'  && getwebsite.websiteslug != ''" class="text-left mr-6" cols="2" sm="2" md="2"> 
                         <v-card class="elevation-12">
                         <v-sheet  class="pa-2 rounnded-lg sheetborder" color="white  lighten-2" >
          <v-avatar  :style="{ 'background-color': getwebsite.websitecolor }" size="100%"  >
                         <img class="websiteimg" :src="adserverURL+'images/'+getwebsite.websitelogo">    
                         </v-avatar>
                       <v-row justify="start">
                            <v-col cols="12" sm="12" md="12" lg="12">
                             <v-chip class="ma-0" color="success" outlined>
                                    Views&nbsp;&nbsp;
                                    <span class="pl-12" color="success"  right>{{getwebsite.impressions}}</span>
                              </v-chip>
                              <span class="ma-3">&nbsp;<br></span>
                              <v-chip class="ma-0" color="primary" outlined>
                                    Clicks&nbsp;&nbsp;
                                    <span color="success" class="pl-12" right>{{getwebsite.clicks}}</span>
                              </v-chip>
                            </v-col>  
                            
                       </v-row>    
                        </v-sheet> 
                       </v-card>  
                      </v-col>
                    </template>   
                  </v-row>
           <v-row align="center" class="stats-container" >
              
                <v-col cols="12" sm="12" md="12">
                    <v-card class="elevation-12">
                       <v-toolbar small class="pa-0"  dark flat>
                           <v-toolbar-title>Statistics</v-toolbar-title>
                        </v-toolbar>
                          <!--- Search ---->
                <v-row> 
                  <v-col cols="1" sm="1" md="1" class="text-right padding-top-0 padding-bottom-0"><br>Search
                   </v-col>
                  <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="websiteid"  :items="websitelist" item-text="publisherName" item-value="publisherId"  @change="getWebsiteBannersList($event)" label="--Select Website--"  class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
                <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="bannerid"  :items="websitebannerslist" item-text="bannertitle" item-value="bannerid" label="--Select Banner--"  class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
                <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="searchfrom_date"  v-model="searchfrom_date"  :close-on-content-click="false"
                                                        :return-value.sync="searchfrom_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field  v-model="searchfromdate"  label="From Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="searchfromdate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="searchfromdate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.searchfrom_date.save(searchfrom_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                                      <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="to_date"  v-model="searchto_date"  :close-on-content-click="false"
                                                        :return-value.sync="searchto_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field            v-model="searchtodate"            label="To Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="searchtodate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="searchtodate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.searchto_date.save(searchto_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                              <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-btn small  depressed color="primary" @click="getSearchWebsiteBannersList()"><v-icon left>mdi-file-search-outline
                                                      </v-icon>Search</v-btn>
                                              </v-col>
              </v-row>
            <!--- End Search----->
                      <v-row>
                           <v-col cols="12" sm="12" md="12" v-for="(getbannerdetail) in getsearchbannerslist" :key="getbannerdetail.bannerid" class="text-left "> 
                                    <v-card class="elevation-12">
                                      <v-toolbar color="blue-grey" class="lighten-2" dark flat>
                                        <v-toolbar-title>{{getbannerdetail.bannertitle}}</v-toolbar-title>
                                      </v-toolbar>
                                      <v-row>         
                                       <v-col cols="4" sm="4" md="4" class="padding-top-0 padding-bottom-0">
                                         <v-col cols="12" sm="12" md="12" class="padding-top-0 padding-bottom-0"> 
                                          <v-row align="center"  justify="center">
                                            
                                            <div class="postionsection" >
                                                <div class="bannercontenthtml bannercontentimage" v-html="bannercontent">
                                                </div>
                                            </div> 
                                            <v-col cols="4" class="pa-2" sm="6" md="6"><h5> App. : </h5></v-col>
                                            <v-col cols="6" class="pa-2" sm="6" md="6">
                                                <div v-for="(getwebsite) in websitestatslist" :key="getwebsite.websiteid">
                                                <span v-if="getwebsite.websiteid == getbannerdetail.websiteid"> <h6>{{getwebsite.name}}</h6> </span>
                                                </div>
                                            </v-col>
                                            <!--                                        
                                          <v-col cols="6" sm="6" class="pa-2" md="6"><h5> Zone : </h5></v-col>
                                            <v-col cols="6" sm="6" class="pa-2" md="6"><h6>Myyyaak- Australia</h6> </v-col>
                                            -->
                                            <v-col cols="6" sm="6" class="pa-2" md="6"><h5> Placement : </h5></v-col>
                                            <v-col cols="6" sm="6" class="pa-2" md="6"><h6>Feed Ad Block (5 USD per 1000 views)</h6> </v-col>


                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h5> Start Date : </h5></v-col>
                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h6>{{getbannerdetail.startdate}}</h6> </v-col>  

                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h5> End Date : </h5></v-col>
                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h6>{{getbannerdetail.enddate}}</h6> </v-col>
                                            
                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h5> Ad. Type : </h5></v-col>
                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h6>{{getbannerdetail.adtype}}</h6> </v-col>
                                            
                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h6> Destination Url : </h6></v-col>
                                            <v-col cols="6" sm="6" md="6" class="pa-2"><h6>{{getbannerdetail.desitnationurl}}</h6> </v-col>
                                        </v-row>   
                                        </v-col>
                                       </v-col>  
                                           <v-col cols="8" sm="8" md="8" class="padding-top-0 padding-bottom-0">
                                                 <!---- Start Preview ---->
                                              <v-row>
                                              <!--
                                              <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-text-field style="display:none;" v-model="bannerviewbyid"  class="padding-top-0 padding-bottom-0" label=""></v-text-field>
                                                    <v-select v-model="bannerviewby"  :items="bannerviewbylist" label="View By"    class="padding-top-0 padding-bottom-0" ></v-select>
                                              </v-col> -->
                                                <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="bannerfrom_date"  v-model="bannerfrom_date"  :close-on-content-click="false"
                                                        :return-value.sync="bannerfrom_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field  v-model="bannerfromdate"  label="From Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="bannerfromdate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="bannerfromdate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.bannerfrom_date.save(bannerfrom_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                                      <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="bannerto_date"  v-model="bannerto_date"  :close-on-content-click="false"
                                                        :return-value.sync="bannerto_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field            v-model="bannertodate"            label="To Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="bannertodate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="bannertodate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.bannerto_date.save(bannerto_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                              <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-btn  small  depressed color="primary" @click="viewbannerstats()"><v-icon left>mdi-file-search-outline
                                                      </v-icon>Search</v-btn>
                                              </v-col>
                                              <v-col cols="3" sm="3" md="3" class="pa-0 padding-bottom-0">
                                                    <div v-if="searchbannerdataexist">  
                                                      <template>
                                                        <div class="text-center">
                                                      <v-btn  color="success" title="Excel Download" class="mx-1"
                                                            fab  small  dark >
                                                              <export-excel 
                                                      title ="Banner Statistics"
                                                      footer="DamnN Group"
                                                      :data="getbannersbylist"
                                                      :fields="bannerstats_json_fields"
                                                      name="bannerstats.xls"
                                                      >
                                                      <v-icon>mdi-file-excel</v-icon>
                                                        </export-excel>
                                                     </v-btn>
                                                     <v-btn  @click="showgraph" color="primary"  class="mx-0"
                                                                fab  small  dark >

                                                          <v-icon v-if="showgraphsection == false" title="Stats. Chart">mdi-chart-line</v-icon>
                                                          <v-icon v-if="showgraphsection == true" title="Stats. Table">mdi-file-table-outline</v-icon> 
                                                        
                                                        </v-btn>

                                                   </div>
                                                   </template>
                                                   </div>
                                                   
                                              </v-col>
                                            </v-row> 
                                                  <v-row align="top" > 
                                                 <v-col cols="12" sm="12" v-if="showtablesection"  md="12">
                                                   <!-- View By Table Data--> 
                                                          <v-data-table  :headers="bannerstatsheaders" :items="getbannersbylist" :items-per-page="5"  class="elevation-2 grey lighten-1" >
                                                                <template v-slot:itemresponce.day="{ itemresponce }">
                                                                       {{itemresponce.day}}
                                                                </template>
                                                                <template v-slot:item.hour="{ item }">
                                                                  {{ item.hour }} 
                                                                </template>
                                                                 <template v-slot:item.impressions="{ item }">
                                                                  {{ item.impressions }} 
                                                                </template>
                                                                 <template v-slot:item.clicks="{ item }">
                                                                  {{ item.clicks }} 
                                                                </template>
                                                                 <template v-slot:item.ctr="{ item }">
                                                                 {{ item.ctr }} 
                                                                </template>
                                                                  <template v-slot:item.hourlydate="{ item }">
                                                                  <a href="javascript:void(0)" @click="viewhoulrybannerstats(item.hourlydate)">
                                                                      <v-icon  small  color="blue" class="mr-2"  >mdi-eye-check</v-icon>
                                                                  </a>
                                                                </template>
                                                          </v-data-table>  
                                                   <!---View By Table Data-->
                                                   
                                                 </v-col>  
                                                 <v-col cols="12"  v-if="showgraphsection">
                                                   <v-card flat>
                                                   <template>
                                                  <div style="width:100%; height:300px;overflow-x:scroll;">
                                                    <bar-chart v-if="showgraphsection"
                                                    :chart-options="activityChartOptions"
                                                    :chart-data="activityChartdata"
                                                    class="walking-speed-chart-activity"
                                                    ></bar-chart>
                                                  </div>
                                                </template>
                                                    </v-card>
                                                 </v-col>  
                                              </v-row>
                                            </v-col>  
                                       </v-row>  
                                       
                                     </v-card>                                                
                           </v-col>
                      </v-row> 
                      </v-card>

                        <!---Dialog-->  
                   <v-dialog v-model="bannerhourlyclosedialog"  width="500">
                      <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                          Hourly Statistics
                        </v-card-title>
                        <v-card-text>
                            <!-- View By Table Data--> 
                        <v-data-table  :headers="hourlybannerstatsheaders" :items="gethourlybannersbylist" :items-per-page="5"  class="elevation-2 grey lighten-1" >
                              <template v-slot:itemresponce.day="{ itemresponce }">
                                      {{itemresponce.day}}
                              </template>
                              <template v-slot:item.hour="{ item }">
                                {{ item.hour }} 
                              </template>
                                <template v-slot:item.impressions="{ item }">
                                {{ item.impressions }} 
                              </template>
                                <template v-slot:item.clicks="{ item }">
                                {{ item.clicks }} 
                              </template>
                                <template v-slot:item.ctr="{ item }">
                                {{ item.ctr }}   
                              </template>
                        </v-data-table>  
                      <!---View By Table Data-->
                        </v-card-text>
                        <v-divider></v-divider>
                                     <v-card-actions class="justify-end">
                                        <v-btn
                                           color ="blue grey"
                                          @click="closehourlystatsdialog"
                                        >Close</v-btn>
                                      </v-card-actions>
                      </v-card>
                    </v-dialog>
               <!----End Dilog----->                                                      
                </v-col>        
           </v-row>         
    </v-container>
    <!--<v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Dashboard</h1>
      </v-row>
    </v-container> -->
    
  </div>
</template>

<script>
var adtypearr = [{text: 'All', value: ''},{text: 'Image', value: 'web'},{text: 'Html', value: 'html'},{text: 'Video', value: 'video'}] ;
var bannerviewbyarr = [{text: 'Daily', value: 'daily'}, {text: 'Hourly', value: 'hourly'}] ;
var filterdatearr = [{text: 'Today', value: 'Today'}, {text: 'Yesterday', value: 'Yesterday'},{text: 'This Week', value: 'This Week'},{text: 'Last Week', value: 'Last Week'},{text: 'This Month', value: 'This Month'},{text: 'Specific dates', value: 'Specific dates'}] ;

import BarChart from '@/components/BarChart'

export default {
  name: "Home",
  data() {
    return {
      balance: 0,
      transactions: null,
      websitelist:[],
      adserverURL : process.env.VUE_APP_ADSERVER_WEB_BASEURL ,
      websiteid:"", 
      websitezonelist:[],
      websitebannerslist:[],
      bannerid:"",
      zoneid:"",
      adtypelist:adtypearr,
      adtype:"" ,
      searchto_date: "",
      searchfrom_date: "",
      searchfromdate: "2022-06-01",
      searchtodate: "2022-06-30",
      webstatsto_date: "",
      webstatsfrom_date: "",
      webstatsfromdate: "2022-06-01",
      webstatstodate: "2022-06-30",

      bannerto_date: "",
      bannerfrom_date: "",
      bannerfromdate: "2022-06-01",
      bannertodate: "2022-06-30",
      bannerviewby : "",
      bannerviewbylist : bannerviewbyarr,
       bannerstatsheaders : [
        { text: 'Date', value: 'day' },
        //{ text: 'Hour', value: 'hour' },
        {text: 'Views',value: 'impressions'},
        { text: 'Clicks', value: 'clicks' },
       // { text: 'Revenue', value: 'revenue' },
         { text: 'CTR', value: 'ctr' },
           { text: 'Hour Stats.', value: 'hourlydate' }, 
      ],
       hourlybannerstatsheaders : [
        { text: 'Date', value: 'day' },
        { text: 'Hour', value: 'hour' },
        {text: 'Views',value: 'impressions'},
        { text: 'Clicks', value: 'clicks' },
       // { text: 'Revenue', value: 'revenue' },
         { text: 'CTR', value: 'ctr' },
      ],
      bannerhourlydialog:false,
     bannerhourlyclosedialog:false, 
      getbannerslist:[],
      getsearchbannerslist:[],
      chartDates: [],
      activityChartdata :"",
      activityChartOptions : "",
      showtablesection:true,
      showgraphsection:false,
      impressionsdata_arr :[],
      clicksdata_arr :[],
        bannerviewbyid:"",
      bannerstats_json_fields: {
            'Date': 'day', 
            'Hour': 'hour',
            'Impressions': 'impressions',
            'Clicks': 'clicks',
            'CTR': 'ctr', 
        },
        searchbannerdataexist:false,
        getbannersbylist:[],
        demobanner:"",
        gethourlybannersbylist:[],
        usersbannerids : "",
        websitestatslist : [],
        filterdates:filterdatearr,
        filterdate:"",
        adplacementslist : []
    };
  },
    components: {
    BarChart,
  },
  mounted() {
    this.getAdserverWebsiteList();
    this.getAdserverUserbanneridsList();
    
   // this.getBalance();
    //this.getTransactions();
    //this.getTimezone();
    //this.getzonelist(4);
  },
  computed: {
  },
  methods: {
      
      viewhoulrybannerstats(getfromdate){
        // alert(this.bannerviewby+"<>"+this.fromdate+"<>"+this.todate+"<>"+this.bannerviewbyid);
             var bannerviewby  = "hourly";
             var fromdate  = getfromdate;
             var todate  = getfromdate;
             var bannerid = this.bannerid;
            
            this.bannerhourlydialog = true;
            this.bannerhourlyclosedialog = true;
              this.$store.dispatch("adserverbannerstats",{bannerviewby:bannerviewby
              ,fromdate:fromdate
              ,todate:todate
              ,bannerid:bannerid
              }, {
              })
              .then(response => {
                for (var i = 0; i < response.data.length; i++) {
                     
                 // if(this.bannerviewby == "hourly")
                 //{    
                  var getdate =  response.data[i].day+" "+response.data[i].hour+":00:00"; 
                 
                // }
                  response.data[i].day  =  require("moment")(
                              response.data[i].day
                              ).format("D/MM/YYYY");
                 //if(this.bannerviewby == "hourly")
                 //{ 
                  response.data[i].hour  =  require("moment")(
                             // response.data[i].hour
                             getdate
                              ).format("HA");            
                      //console.log(datett); 
                 //}     
                  var getctr = ""
                    if(response.data[i].impressions > 0 && response.data[i].clicks >0)
                    {
                      getctr =  (response.data[i].clicks / response.data[i].impressions * 100).toFixed(2);
                       getctr =  getctr+"%";
                    }                       
                    response.data[i].ctr =  getctr;


                }
               this.gethourlybannersbylist = response.data;
               console.log("Hourly Stats.");
               console.log(this.gethourlybannersbylist);
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Banner Stats List error");
                console.log(error);
              });
      }, 
    closehourlystatsdialog()
      {
         this.bannerhourlyclosedialog = false;  
      },
     showgraph()
      { 
       

        this.activityChartdata = {
        labels: [],
        datasets: [
           {
            label: "Impressions",
            backgroundColor: "lightblue",
            borderColor: "blue",
            borderWidth: 1,
            data: []
        },
        {
            label: "Clicks",
            backgroundColor: "lightgreen",
            borderColor: "green",
            borderWidth: 1,
            data: []
        }
          ]
      };

       this.activityChartOptions = {
          responsive: false,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: false,
          },
          aspectRatio:4 ,//(width/height),
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                    beginAtZero:true,
               //   stepSize: 10,
                  min: 0,
                  max: 100
                },
              },
            ],
         
          },
        };




        this.chartDates = [];
        this.impressionsdata_arr = [];
         this.clicksdata_arr = [];
        // Here Fetch Data For Chart   
         for (var i = 0; i < this.getbannersbylist.length; i++) 
               {
                 this.chartDates.push(this.getbannersbylist[i].day);
                 this.impressionsdata_arr.push(this.getbannersbylist[i].impressions);
                 this.clicksdata_arr.push(this.getbannersbylist[i].clicks);
               }    
               this.activityChartdata.datasets[0].data = this.impressionsdata_arr;     
               this.activityChartdata.datasets[1].data = this.clicksdata_arr;
               this.activityChartdata.labels = this.chartDates;
        // End
         console.log(this.impressionsdata_arr);

        if(this.showgraphsection == true)
        {
          this.showgraphsection = false;
          this.showtablesection = true;
        }else
        {

          this.showgraphsection = true;
          this.showtablesection = false;
        }
      },
      viewbannerstats(){
        // alert(this.bannerviewby+"<>"+this.fromdate+"<>"+this.todate+"<>"+this.bannerviewbyid);
             var bannerviewby  = "daily";//this.bannerviewby;
             var fromdate  = this.bannerfromdate;
             var todate  = this.bannertodate;
             var bannerid = this.bannerid;
            //  this.chartDates = [];
            //  this.impressionsdata_arr = [];
            //  this.clicksdata_arr = [];
              this.showgraphsection = false;
              this.showtablesection = true;
              this.getbannersbylist = [];
              this.gethourlybannersbylist =[];   

             if(bannerviewby =="")
             { 
              this.$alert("Please select view by.","View By","fail");
               return false;
             }
              this.$store.dispatch("adserverbannerstats",{bannerviewby:bannerviewby
              ,fromdate:fromdate
              ,todate:todate
              ,bannerid:bannerid
              }, {
              })
              .then(response => {

             
                for (var i = 0; i < response.data.length; i++) {
                     
                  if(this.bannerviewby == "hourly")
                 {    
                  var getdate =  response.data[i].day+" "+response.data[i].hour+":00:00"; 
                 }
                 response.data[i].hourlydate = response.data[i].day;
                  response.data[i].day  =  require("moment")(
                              response.data[i].day
                              ).format("D/MM/YYYY");
                 if(this.bannerviewby == "hourly")
                 { 
                  response.data[i].hour  =  require("moment")(
                             // response.data[i].hour
                             getdate
                              ).format("HA");            
                      //console.log(datett); 
                 }     

                     var getctr = ""
                    if(response.data[i].impressions > 0 && response.data[i].clicks >0)
                    {
                      getctr =  (response.data[i].clicks / response.data[i].impressions * 100).toFixed(2);
                       getctr =  getctr+"%";
                    }                       
                    response.data[i].ctr =  getctr;
               


                }
                 this.getbannersbylist = response.data;
                

              if(this.getbannersbylist !="")
              {
                this.searchbannerdataexist = true;
              }
              
              // console.log(response);
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Banner Stats List error");
                console.log(error);
              });
      },
    getBalance() {
      this.$store.dispatch("retrieveBalance").then(() => {
        this.balance = this.$store.getters.balance;
      });
    },
    getTransactions() {
      if (this.transactions === null) {
        this.$store.dispatch("retrieveTransactions").then(() => {
          this.transactions = this.$store.getters.transactions;
        });
      }
    },
    getTimezone() {
      this.timezone = this.$moment.tz.guess();
    },
     getAdserverWebsiteList() {
      this.$store.dispatch("retrieveAdserverWebsitesList", {
        })
        .then(response => {
          this.websitelist = response;
         // console.log(this.websitelist);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website List error");
          console.log(error);
        });
    },
   getzonelist(getwebsiteid)
          {
              this.$store.dispatch("retrieveWebsiteZoneList",{websiteid : getwebsiteid}, {
              })
              .then(response => {
                console.log(response.data);
                this.websitezonelist = response.data;
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Website Zone List error");
                console.log(error);
              });
          },
     getBannersList() { 
      this.$store.dispatch("quizstarbannerlist",
       {
           websiteid : this.websiteid,
           adtype : this.adtype,
           fromdate : this.searchfromdate,
           todate : this.searchtodate 
        }
      ).then(response => {  
       
            for (var i = 0; i < response.data.length; i++) {
                 
                  response.data[i].startdate  =  require("moment")(
                              response.data[i].startdate
                              ).format("D/MM/YYYY");
                  
                  response.data[i].enddate  =  require("moment")(
                             response.data[i].enddate
                              ).format("D/MM/YYYY"); 

                  
                }


        //this.getbannerslist = this.$store.state.quizstarbannerlist;
        this.getbannerslist = response.data;
         console.log(this.$store.getters.quizstarbannerlist);
      });
    },     
  
  getWebsiteBannersList(getwebsiteid) { 
      this.$store.dispatch("quizstarwebsitebannerlist",
       {
           websiteid : getwebsiteid,
       }
      ).then(response => {  
       this.websitebannerslist = response.data;
      });
    },     
   getSearchWebsiteBannersList() { 
      this.$store.dispatch("quizstardashboardsearchbannerlist",
       {
           websiteid : this.websiteid,
           bannerid : this.bannerid,
           fromdate : this.searchfromdate,
           todate : this.searchtodate 
        }
      ).then(response => {  
       
            for (var i = 0; i < response.data.length; i++) {
                 
                  response.data[i].startdate  =  require("moment")(
                              response.data[i].startdate
                              ).format("D/MM/YYYY");
                  
                  response.data[i].enddate  =  require("moment")(
                             response.data[i].enddate
                              ).format("D/MM/YYYY"); 

                      this.adtype = response.data[i].adtype;
                      
                     if(this.adtype =="html")
                        {
                        this.bannercontent = response.data[i].htmltemplate;
                        }

                        if(this.adtype =="web")
                        {
                          this.demobanner = this.adserverURL+"/images/"+response.data[i].bannerimage; 
                          this.bannercontent='<img class="list-item" width = "100%" height = "100%" alt="Avatar" src="'+this.demobanner+'" >'
                        }

                          if(this.adtype =="video")
                        {
                              this.demobanner = "";
                              var videohtml = '<video width = "100%" height = "100%" controls ><source src="'+response.data[i].advast_video_filename+'" type ="video/mp4"></video>';
                              this.bannercontent = videohtml;
                        }          
                            
                }
        this.getsearchbannerslist = response.data;
        this.getbannersbylist = [];
              this.gethourlybannersbylist =[];   
      });
    },     
    getAdserverUserbanneridsList() {
      this.$store.dispatch("retrieveAdserveruserbanneridsList", {
        })
        .then(response => {
         // this.websitelist = response;
         this.usersbannerids = response.data.data.bannerids;
         this.getAdserverWebsitesStats();
         // console.log(response.data);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("USer Banner Ids List error");
          console.log(error);
        });
    },
    getAdserverWebsitesStats() {

var fromdate = ""; var todate = "";
var curr = new Date; // get current date
var first = curr.getDate(); // First day is the day of the month - the day of the week
//- curr.getDay()
var firstday = ""; var lastday = "";

//var filterdatearr = 'Today'
 //'Yesterday'
 //'This Week'
 //'Last Week'
 //'This Month'
 //'Specific dates'
       if(this.filterdate =="Today")
       {
          firstday = new Date(curr.setDate(first)).toUTCString();
          lastday = firstday;
       }else if(this.filterdate =="Yesterday")
       {
          //firstday = new Date(curr.setDate(first)).toUTCString();
          lastday = new Date(curr.setDate(first -1)).toUTCString();
          firstday = lastday;
       }
       else if(this.filterdate =="This Week")
       {
         var getcurrentdate = new Date(curr.setDate(first)).toUTCString();
         firstday = require("moment")(getcurrentdate).startOf('week').format("YYYY-MM-D");
         lastday   = require("moment")(getcurrentdate).endOf('week').format("YYYY-MM-D");
//alert(startOfWeek +" "+endOfWeek);
        // firstday = new Date(curr.setDate(first)).toUTCString();
         // lastday = new Date(curr.setDate(first +6)).toUTCString();
       }
       else if(this.filterdate =="Last Week")
       {
           var getlastweekcurrentdate = new Date(curr.setDate(first - 6)).toUTCString();
         firstday = require("moment")(getlastweekcurrentdate).startOf('week').format("YYYY-MM-D");
         lastday   = require("moment")(getlastweekcurrentdate).endOf('week').format("YYYY-MM-D");
      
       }
       else if(this.filterdate =="This Month")
       {
          firstday = new Date(curr.getFullYear(), curr.getMonth(), 1);
          lastday = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
        }
       else if(this.filterdate =="Specific dates")
       {
          firstday = this.webstatsfromdate;
          lastday = this.webstatstodate;
       }else{
           firstday = new Date(curr.setDate(first)).toUTCString();
          lastday = firstday;
       }

      
       /*
var last = first - 6; // last day is the first day + 6

var firstday = new Date(curr.setDate(first)).toUTCString();
var lastday = new Date(curr.setDate(last)).toUTCString();
firstday =  require("moment")(
                              firstday
                              ).format("YYYY-MM-D");
lastday =  require("moment")(
                              lastday
                              ).format("YYYY-MM-D");                              
alert(firstday +"  "+lastday );
      */
     fromdate =  require("moment")(
                              firstday
                              ).format("YYYY-MM-D");
     todate =  require("moment")(
                              lastday
                              ).format("YYYY-MM-D");                              


      this.$store.dispatch("retrieveAdserverWebsitesStats",{
        bannerids : this.usersbannerids,
        fromdate : fromdate,
        todate : todate 
      } ,{
        })
        .then(response => {
          console.log("User Websites Stats.");
          this.websitestatslist = response.websitedays.data;
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("USer Banner Ids List error");
          console.log(error);
        });
    },



  }
};
</script>
<style>
.websiteimg{width:80px !important;height: 80px !important;}
.stats-container  header {height: 35px !important;}
.stats-container  .v-toolbar__content {height: 35px !important;}
.stats-container   .v-toolbar__title{font-size: 1.0em;}
</style>
<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
.sheetborder{}

</style>